export default __webpack_public_path__ + "static/media/xxEmailLogo.437d194c.png";